import React, { useContext, useState } from "react";
import { DataContext } from "../contexts/DataContext";

const DirectionButton = () => {
  const { setDateDirection, setArticleListPosition } = useContext(DataContext);

  const [direction, setDirection] = useState(true);
  const directionHandler = (e) => {
    e.preventDefault();
    setDirection(!direction);
    setArticleListPosition(1);
    direction ? setDateDirection("ASC") : setDateDirection("DESC");
  };

  return (
    <span className="order_direction">
      Sort by:{" "}
      <button
        onClick={directionHandler}
        className={direction === true ? "direction_latest" : "direction_oldest"}
      >
        {direction === true ? "Latest" : "Oldest"}{" "}
        <span className="button_arrow_container"></span>
      </button>
    </span>
  );
};

export default DirectionButton;
